// extracted by mini-css-extract-plugin
export default {"moveable":"WMcSqFAx0p"};